import { NewsThumbnailSkeleton } from '@terminal/components/news-thumbnail-skeleton/NewsThumbnailSkeleton';
import React from 'react';

export const NewsLoadingState = () => (
  <>
    <NewsThumbnailSkeleton />
    <NewsThumbnailSkeleton />
    <NewsThumbnailSkeleton />
  </>
);
